export const deleteContact = id => ({
    type: 'deleteContact',
    id
})